/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Smart Sash Admin API
 * RESTful API for Smart Sash device management, user authentication, and system administration
 * OpenAPI spec version: 0.13.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetApiOauthCallbackParams,
  OAuthLinkRequestDto,
  OAuthRequestDto,
  OAuthRequestResponse,
  ProblemDetails
} from '../../models';

import { customInstance } from '../../../http/customInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const postApiOauthRequest = (
    oAuthRequestDto?: OAuthRequestDto,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<OAuthRequestResponse>(
      {url: `/api/oauth/request`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: oAuthRequestDto, signal
    },
      options);
    }




export const getPostApiOauthRequestMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOauthRequest>>, TError,{data?: OAuthRequestDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiOauthRequest>>, TError,{data?: OAuthRequestDto}, TContext> => {

const mutationKey = ['postApiOauthRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiOauthRequest>>, {data?: OAuthRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  postApiOauthRequest(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiOauthRequestMutationResult = NonNullable<Awaited<ReturnType<typeof postApiOauthRequest>>>
    export type PostApiOauthRequestMutationBody = OAuthRequestDto | undefined
    export type PostApiOauthRequestMutationError = ProblemDetails

    export const usePostApiOauthRequest = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOauthRequest>>, TError,{data?: OAuthRequestDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiOauthRequest>>,
        TError,
        {data?: OAuthRequestDto},
        TContext
      > => {
      return useMutation(getPostApiOauthRequestMutationOptions(options), queryClient);
    }
    export const getApiOauthCallback = (
    params?: GetApiOauthCallbackParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<unknown>(
      {url: `/api/oauth/callback`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetApiOauthCallbackInfiniteQueryKey = (params?: GetApiOauthCallbackParams,) => {
    return [
    'infinite', `/api/oauth/callback`, ...(params ? [params] : [])
    ] as const;
    }

export const getGetApiOauthCallbackQueryKey = (params?: GetApiOauthCallbackParams,) => {
    return [
    `/api/oauth/callback`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiOauthCallbackInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getApiOauthCallback>>>, TError = void | ProblemDetails>(params?: GetApiOauthCallbackParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiOauthCallbackInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOauthCallback>>> = ({ signal }) => getApiOauthCallback(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiOauthCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiOauthCallbackInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOauthCallback>>>
export type GetApiOauthCallbackInfiniteQueryError = void | ProblemDetails


export function useGetApiOauthCallbackInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiOauthCallback>>>, TError = void | ProblemDetails>(
 params: undefined |  GetApiOauthCallbackParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiOauthCallback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOauthCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiOauthCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiOauthCallbackInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiOauthCallback>>>, TError = void | ProblemDetails>(
 params?: GetApiOauthCallbackParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiOauthCallback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOauthCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiOauthCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiOauthCallbackInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiOauthCallback>>>, TError = void | ProblemDetails>(
 params?: GetApiOauthCallbackParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiOauthCallbackInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getApiOauthCallback>>>, TError = void | ProblemDetails>(
 params?: GetApiOauthCallbackParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getApiOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiOauthCallbackInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetApiOauthCallbackQueryOptions = <TData = Awaited<ReturnType<typeof getApiOauthCallback>>, TError = void | ProblemDetails>(params?: GetApiOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiOauthCallbackQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiOauthCallback>>> = ({ signal }) => getApiOauthCallback(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiOauthCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiOauthCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof getApiOauthCallback>>>
export type GetApiOauthCallbackQueryError = void | ProblemDetails


export function useGetApiOauthCallback<TData = Awaited<ReturnType<typeof getApiOauthCallback>>, TError = void | ProblemDetails>(
 params: undefined |  GetApiOauthCallbackParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOauthCallback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOauthCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiOauthCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiOauthCallback<TData = Awaited<ReturnType<typeof getApiOauthCallback>>, TError = void | ProblemDetails>(
 params?: GetApiOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOauthCallback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiOauthCallback>>,
          TError,
          Awaited<ReturnType<typeof getApiOauthCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiOauthCallback<TData = Awaited<ReturnType<typeof getApiOauthCallback>>, TError = void | ProblemDetails>(
 params?: GetApiOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiOauthCallback<TData = Awaited<ReturnType<typeof getApiOauthCallback>>, TError = void | ProblemDetails>(
 params?: GetApiOauthCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiOauthCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiOauthCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiOauthLink = (
    oAuthLinkRequestDto?: OAuthLinkRequestDto,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<boolean>(
      {url: `/api/oauth/link`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: oAuthLinkRequestDto, signal
    },
      options);
    }




export const getPostApiOauthLinkMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOauthLink>>, TError,{data?: OAuthLinkRequestDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiOauthLink>>, TError,{data?: OAuthLinkRequestDto}, TContext> => {

const mutationKey = ['postApiOauthLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiOauthLink>>, {data?: OAuthLinkRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  postApiOauthLink(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiOauthLinkMutationResult = NonNullable<Awaited<ReturnType<typeof postApiOauthLink>>>
    export type PostApiOauthLinkMutationBody = OAuthLinkRequestDto | undefined
    export type PostApiOauthLinkMutationError = ProblemDetails

    export const usePostApiOauthLink = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiOauthLink>>, TError,{data?: OAuthLinkRequestDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiOauthLink>>,
        TError,
        {data?: OAuthLinkRequestDto},
        TContext
      > => {
      return useMutation(getPostApiOauthLinkMutationOptions(options), queryClient);
    }
